import React from 'react';

interface IProps {
    text: string;
}

export const Operator = (props: IProps) => {
    return (
        <div className='operator'>
            {props.text}
        </div>
    );
};
